export const Checkout = {
    progressDeliveryStep: 'checkout_progress_delivery',
    progressPaymentStep: 'checkout_progress_payment',
    progressConfirmationStep: 'checkout_progress_confirmation',
    progressShippingStep: 'checkout_progress_shipping',
    progressBillingStep: 'checkout_progress_billing',

    billingPageTitle: 'billing_page_title',
    billingPageSubtitle: 'billing_page_subtitle',
    deliveryPageTitle: 'delivery_page_title',
    deliveryOptionsTitle: 'delivery_options_title',
    homeDeliveryTitle: 'home_delivery_title',
    homeDeliveryOptionsAvailable: 'home_delivery_options_available',
    clickCollectTitle: 'click_collect_title',
    deliveryInstructionsLabel: 'delivery_intructions',
    continueCheckoutLabel: 'continue_checkout',
    chooseBillingFromBookLablel: 'billing_choose_from_book',
    newBillingLabel: 'new_billing_address',
    paymentPageTitle: 'payment_page_title',
    paymentMethodSelectionTitle: 'payment_method_selection_title',
    placeOrderLabel: 'place_order',
    creditCardSelectorLabel: 'credit_card_selector',
    newCreditCardLabel: 'add_credit_card',
    cardSaveLabel: 'save_credit_card',
    orderConfirmationPageTitle: 'order_confirmation_page_title',
    orderConfirmationTitle: 'order_confirmation_title',
    orderConfirmationMessage: 'order_confirmation_message',
    otherProductsTitle: 'other_products_component_title',
    signInOrSignUpTitle: 'sign_in_or_sign_up_title',
    signInOrSignUpText: 'sign_in_or_sign_up_text',
    signInOrSignUpLabel: 'sign_in_or_sign_up',
    checkoutLabel: 'checkout',
    billingToLabel: 'billing_to',
    billingAddress: 'billing_address',
    orderNumberLabel: 'order_number',
    orderHistoryTitle: 'order_history_title',
    seeAllOrders: 'see_all_orders',
    noOrdersMessage: 'no_orders_message',
    discoverNewProducts: 'discover_new_products',
    allOrders: 'all_orders',
    onTheWay: 'on_the_way',
    trackPackageLabel: 'track_package',
    orderDetailsTitle: 'order_details_title',
    billingInformation: 'billing_information',
    carrierLabel: 'carrier',
    trackingNumberLabel: 'tracking_number',
    paymentMethodLabel: 'payment_method',
    temporaryModuleTitle: 'temporary_module_title',
    orderPlacedLabel: 'order_placed',
    orderStatusLabel: 'order_status',
    orderInformationLabel: 'order_information',
    viewOrderDetailsText: 'view_order_details',
    emailSignup: 'email_signup',

    // shipping
    shippingPageTitle: 'shipping_page_title',
    defaultShippingAddress: 'default_shipping_address',
    shippingAddress: 'shipping_address',
    shippingToLabel: 'shipping_to',
    shippingMethod: 'shipping_method',
    sameBillingCheckboxLabel: 'same_billing_address_checkbox',
    billingAddressTitle: 'billing_address_title',

    // order and order history
    orderTypeOnlineLabel: 'order_type_online',

    // item count
    orderItemCountSingular: 'order_item_count_singular',
    orderItemCountPlural: 'order_item_count_plural',

    // order status
    orderStatusCancelled: 'order_status_cancelled',
    orderStatusDispatching: 'order_status_dispatching',
    orderStatusDelivered: 'order_status_delivered',
    orderStatusProcessing: 'order_status_processing',

    // adyen specific helpful links
    helpfulLink1: 'adyen_helpful_link_1',
    helpfulLink2: 'adyen_helpful_link_2',
    helpfulLink3: 'adyen_helpful_link_3',
    helpfulLink4: 'adyen_helpful_link_4',
    helpfulLink5: 'adyen_helpful_link_5',
    helpfulLink6: 'adyen_helpful_link_6',
    helpfulLink7: 'adyen_helpful_link_7',

    // card
    cardDebitCardOption: 'credit_debit_card_option',
    makeDefaultCard: 'make_default_card',
    defaultCard: 'default_card',
    deleteCard: 'delete_card',
    cardExpiration: 'card_expiration',
    cardExpired: 'card_expired',
    noCardTokensMessage: 'no_card_tokens_message',
    cvvLabel: 'cvv',

    // cash on delivery
    codPaymentOption: 'cod_payment_option',

    // alipay
    alipayPaymentOption: 'alipay_payment_option',

    // afterpay
    afterpayPaymentMethod: 'afterpay_payment_method',
    afterpayAddressWarning: 'afterpay_address_warning',
    afterpayNotEligibleMessage: 'afterpay_not_eligible_message',
    afterpayInstallmentPayInMessage: 'afterpay_installment_pay_in_message',
    afterpayPaymentAgreementLink: 'afterpay_payment_agreement_link',
    continueWithAfterpay: 'continue_with_afterpay',

    // delete payment
    deletePayment: 'delete_payment',
    deletePaymentDefault: 'delete_payment_default',
    deletePaymentConfirm: 'delete_payment_confirm',
    deletePaymentCancel: 'delete_payment_cancel',

    // default payment
    choosePayment: 'choose_another_payment',
    choosePaymentUseAsDefault: 'choose_another_payment_use_as_default',
    choosePaymentConfirm: 'choose_another_payment_confirm',
    choosePaymentCancel: 'choose_another_payment_cancel',
    continueWithPayPal: 'continue_with_paypal',
    payPalLabel: 'paypal_payment_method',

    // product reorder
    reorderButtonLabel: 'reorder',
    reorderFreePromoButtonLabel: 'reorder_free_promo',
    reorderProductNoLongerAvailable: 'reorder_product_no_longer_available',

    // click and collect
    searchPickupPointButtonText: 'search_pickup_point',
    findPickupPointText: 'find_pickup_point',
    addressSearchPlaceholder: 'address_search_placeholder',
    nearestPickUpPointText: 'nearest_pickup_point',
    storeClosedText: 'store_closed',
    openingHoursText: 'opening_hours',
    selectLocationButtonText: 'select_location',
    daysOfTheWeek: 'days_of_the_week',
    noPickUpPointsTitle: 'no_pickup_points_title',
    noPickUpPointsCopy: 'no_pickup_points',
    searchPickupPointsAgainCopy: 'search_pickup_points_again',
    loadMoreLocationsText: 'load_more_locations',
    markerIconURL: 'marker_logo_url',
    changeLocationButtonText: 'change_location',
    selectedStoreText: 'selected_store_text',
    pickupPointInformationCopy: 'pickup_point_information',
    pickupInformation: 'pickup_information',
    clickAndCollectPopupInfoTitle: 'popup_info_collect_from_local_shop',
    clickAndCollectPopupInfoSubTitle: 'popup_info_subtitle',
    clickAndCollectPopupInfoGetNotifiedTitle: 'get_notified',
    clickAndCollectPopupInfoGetNotifiedCopy: 'popup_info_get_notified_copy',
    clickAndCollectPopupInfoProvideDocumentsTitle: 'provide_documents',
    clickAndCollectPopupInfoProvideDocumentsCopy: 'popup_info_provide_documents_copy',
    clickAndCollectPopupInfoSignPackageTitle: 'sign_package',
    clickAndCollectPopupInfoSignPackageCopy: 'popup_info_sign_package_copy',
    clickAndCollectPopupInfoOrderDispatchCopy: 'popup_info_order_dispatch',
    clickAndCollectPopupInfoSmallPrint: 'popup_info_small_print',

    //UPS address validation
    upsAddressValidationTitleLabel: 'ups_validation_title',
    upsAddressValidationSubtitleLabel: 'ups_validation_subtitle',
    upsAddressValidationRecommendedAddressLabel: 'ups_validation_recommended_address',
    upsAddressValidationEnteredAddressLabel: 'ups_validation_entered_address',
    upsAddressValidationUseAddressLabel: 'ups_validation_use_address',
    upsAddressValidationKeepAddressLabel: 'ups_validation_keep_address',

    //gift card redemption
    giftCardNumberLabel: 'gift_card_number',
    giftCardPinLabel: 'gift_card_pin',
    giftCardApplyAnotherLabel: 'gift_card_apply_another',
    giftCardMoreInfoLabel: 'gift_card_more_info',
    giftCardAppliedMessage: 'gift_card_applied',
    giftCardRemovedMessage: 'gift_card_removed',
    giftCardBalanceLabel: 'gift_card_balance'
};
